module.exports = __webpack_public_path__ + "img/gears.f7b057c2.png";